import styled, { css } from 'styled-components';

import { CrossCircle } from '@xsolla/ui-icons';

import { project_colors } from '../../../../../constants';

const hoverStyles = css`
  :hover {
    background-color: ${project_colors.LIGHT_GREY};
    border: 1px solid ${(props) => props.theme.colors.brand};
  }
`;

const disabledStyles = css`
  cursor: default;
  pointer-events: none;
`;

export const Container = styled.div<{ disabled?: boolean }>`
  ${(props) => props.theme.typography.body};
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.stroke};
  cursor: pointer;
  ${(props) => !props.disabled && hoverStyles}
  ${(props) => props.disabled && disabledStyles}
`;

export const CrossIcon = styled(CrossCircle)<{ disabled?: boolean }>`
  color: ${project_colors.NEUTRAL_LIGHT};
  ${Container}:hover & {
    color: ${(props) => !props.disabled && props.theme.colors.brand};
  }
`;
